<script lang="ts">
  import type { PageData } from "./$types";
  import type { Article } from "types/backend/models/article.entity";
  import Breadcrumb from "$components/breadcrumb/index.svelte";
  import { Views, screenSize } from "$lib/store/detect-view";
  import MetaComponent from "$components/meta/index.svelte";

  export let data: PageData;
  const { locale, article } = data;

  const { title, content, contentImg, createdAt, author } = article as Article & {
    author: {
      forename: string;
      surname: string;
      _id: string;
    };
  };
</script>

<MetaComponent meta={article?.meta} />

<article class="article">
  <div class="background" style={`background: url(${contentImg?.path ?? "/default.png"}) center / cover no-repeat`}>
    <div class="content-grid center">
      <h1>{title}</h1>
      <Breadcrumb
        paths={[{ url: "/", name: "home" }, { url: "/news", name: "news" }, { name: title }]}
        macro={true}
        textCenter={$screenSize !== Views.DESKTOP}
      />

      {#if author?.forename && author?.surname}
        <div class="author">
          <p>Written by:</p>
          <strong>{author.forename ?? ""} {author.surname ?? ""}</strong>
        </div>
      {/if}
    </div>
  </div>
  <section class="news-content generic-content">{@html content}</section>
</article>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;

  .article {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .background {
    width: 100%;
    min-height: 12.5em;
    @include desktop {
      min-height: 16.75em;
    }

    .content-grid {
      background-color: rgba(0, 0, 0, 0.4);

      // Breadcrumb Arrow - make it white
      :global(ol li.arrow i) {
        filter: invert(1);
      }
    }

    .center {
      justify-items: center;
      padding-top: 8.53em;
      padding-bottom: 2.08em;
      & :global(.breadcrumb) {
        width: unset;
      }

      .author {
        display: grid;
        grid-template-columns: auto auto;
        justify-content: start;
        gap: 10px;
        p,
        strong {
          font-family: var(--secondary-font);
          font-size: 13px;
        }

        @include desktop {
          p,
          strong {
            line-height: 1.875rem;
          }
        }
      }

      h1,
      p,
      strong,
      & :global(span) {
        color: #fff;
      }

      h1 {
        text-align: center;
        font-family: var(--secondary-font);
        font-size: 1.25em;
        margin-bottom: 0px;
        padding: 0;
        line-height: 1em;
        padding: 5px 2px;

        @include desktop {
          padding: 10px 5px;
          font-size: 2.1875em;
          margin-bottom: 7px;
          padding: 0;
          line-height: 1em;
        }
      }
      & :global(span) {
        font-size: 0.8125em;
        line-height: 1.875em;
        @include desktop {
          font-size: 1em;
        }
      }
    }
  }

  section {
    margin: 74px auto 40px;
    gap: 20px;
    width: 90%;
    padding: 0;

    @include desktop-xl {
      width: 100%;
      margin: 74px auto 30px;
      padding: 0 132px;
    }

    :global(> *) {
      padding: unset;
      /* margin: 1.25em 0; */
    }

    :global(img) {
      width: 100%;
      object-fit: cover;
      margin: 1.25em 0;
      @include desktop {
        max-height: 30em;
      }
    }
  }

  .news-content {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0 20px;
    @include tablet {
      max-width: 1320px;
    }
  }
</style>
